'use strict';

export const   setAutologinPending = state => { state.isAutologinPending = true  };
export const unsetAutologinPending = state => { state.isAutologinPending = false };

//=================================================================================================================

export const showDisclaimerDialog = state => { state.disclaimerDialogVisible = true  };
export const hideDisclaimerDialog = state => { state.disclaimerDialogVisible = false };

//=================================================================================================================

export const   setDisclaimerAccepted = state => { state.disclaimerAccepted = true  };
export const unsetDisclaimerAccepted = state => { state.disclaimerAccepted = false };

//=================================================================================================================

export const setAuthSSOError         = (state, error) => { state.authSSOError         = error };
export const setAuthTokenError       = (state, error) => { state.authTokenError       = error };
export const setAuthCredentialsError = (state, error) => { state.authCredentialsError = error };
